<template>
  <div :class="['proa-card', { material: !flat, 'no-padding': noPadding }]">
    <div v-if="$slots.header" :class="['proa-card-header', { 'border-none': noHeaderBorder }]">
      <slot name="header"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ProaCard',
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    noHeaderBorder: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    backFunction: Function
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.proa-card {
  background-color: white;

  &.no-padding {
    width: calc(100% + 40px);
    height: calc(100% + 40px) !important;
    margin: -20px;

    @include mq(md) {
      width: 100%;
      height: 100% !important;
      margin: 0;
    }
  }
  .proa-card-header {
    padding: 15px 20px;

    &:not(.border-none) {
      border-bottom: 1px solid $dark-border-color;
    }
  }
}
.material {
  box-shadow: 0px 0px 4px #00000026;
  border-radius: 4px;
}
</style>
